export default "__VITE_ASSET__yLApquhk__"